import script from "./button-container.vue?vue&type=script&setup=true&lang=ts"
export * from "./button-container.vue?vue&type=script&setup=true&lang=ts"

import "./button-container.vue?vue&type=style&index=0&id=d99673ea&lang=scss"

const __exports__ = script;

export default __exports__